module.exports = __webpack_public_path__ + "img/header_phone_2.96af28b9.webp";